import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

import { TwitchIcon, YouTubeIcon, SignalIcon, HappyFaceLogo, ChatIcon, SlideshowIcon } from 'components/Svg';
import Tooltip from 'components/Tooltip';

export const TwitchStatus = ({ on, onClick, ...props}) => {
  return (
    <Tooltip tooltip={`Stream: ${on ? 'on' : 'off'}`}>
      <div 
        className={cx("g-channel-status", "stream", "twitch", { on, off: !on })}
        onClick={onClick}>
        <TwitchIcon />
        <SignalIcon />
      </div>
    </Tooltip>); 
}

export const YouTubeStatus = ({ on, onClick, ...props}) => {
  return (
    <Tooltip tooltip={`Stream: ${on ? 'on' : 'off'}`}>
      <div 
        className={cx("g-channel-status", "stream", "youtube", { on, off: !on })}
        onClick={onClick}>
        <YouTubeIcon />
        <SignalIcon />
      </div>
    </Tooltip>); 
}

export const OverlayStatus = ({ on, onClick, ...props }) => {
  return (
    <Tooltip tooltip={`Slideshow: ${on ? 'on' : 'off'}`}>
      <div
        className={cx("g-channel-status", "overlay", { on, off: !on })}
        onClick={onClick}>
        <SlideshowIcon />
      </div>
    </Tooltip>
  );
}

export const ChatStatus = ({ on, onClick, ...props }) => {
  return (
    <Tooltip tooltip={`Chatbot: ${on ? 'on' : 'off'}`}>
      <div
        className={cx("g-channel-status", "chat", { on, off: !on })}
        onClick={onClick}>
        <ChatIcon />
      </div>
    </Tooltip>);
}

export const StreamStatus = ({ on, onClick, ...props }) => {
  return (
    <Tooltip tooltip={`Stream: ${on ? 'on' : 'off'}`}>
      <div
        className={cx("g-channel-status", "stream", { on, off: !on })}
        onClick={onClick}>
        <SignalIcon />
      </div>
    </Tooltip>);
}
